import React, {Component} from 'react'
import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import TicketProgressDisplay from "components/Parts/TicketProgressDisplay";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import TextField from "@material-ui/core/TextField";
import moment from "moment-timezone";
import CardContent from "@material-ui/core/CardContent";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Checkbox from "@material-ui/core/Checkbox";
import Search from "@material-ui/icons/Search";
import {MANAGER_PLUS_ROLES} from "../../constants/UserRoles";
import {Objects} from "../index";
import Types from "../../constants/Types";
import Collections from "../Collections";
import GradeComponent from "../Objects/GradeComponent";
import TicketScoreBreakdown from "../Parts/TicketScoreBreakdown"
import Tooltip from "@material-ui/core/Tooltip";
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";
import TicketAuditReviewLink from "utils/TicketAuditReviewLink";
import TrendStackedMetric from "./TrendStackedMetric";
import {goToHelpdeskContacted} from "components/Header/Notifications";

// Function to determine the letter grade
const getLetterGrade = (score) => {
	if (score >= 90) {
		return 'A';
	} else if (score >= 80) {
		return 'B';
	} else if (score >= 70) {
		return 'C';
	} else if (score >= 60) {
		return 'D';
	} else {
		return 'F';
	}
};

// Function to determine the grade sign (+/-)
const getGradeSign = (score) => {
	if (score <= 60) {
		return '';
	} else if (score >= 100) {
		return '+';
	}
	if (score % 10 >= 7) {
		return '+';
	} else if (score % 10 <= 3) {
		return '-';
	} else {
		return '';
	}
};

const EngineerHDCard = React.memo(class extends Component {
	constructor() {
		super();
		this.state = {
			modal_obj: null,
			waived_items: [],
			waived_modal: false,
		};

	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	renderCachedDataReport = (engineer) => {
		const report = engineer?.cached_data_report;
		if (!report || report.parsed !== true) {
			return (
				<p>
					This phone has cached data, but it has not sent a per-ticket breakdown.
					The list appears after the engineer opens Calendar on a current build.
				</p>
			);
		}
		if (!Array.isArray(report.tickets) || report.tickets.length === 0) {
			return <p>The last Calendar report did not include any ticket rows.</p>;
		}
		return (
			<div>
				{report.reported_at && <p>Last reported: {report.reported_at}</p>}
				{report.tickets.map((row) => {
					const counts = [
						row.task_lists > 0 ? `${row.task_lists} task list item${row.task_lists === 1 ? "" : "s"}` : null,
						row.images > 0 ? `${row.images} image${row.images === 1 ? "" : "s"}` : null,
						row.forms > 0 ? `${row.forms} form${row.forms === 1 ? "" : "s"}` : null,
						row.notes > 0 ? `${row.notes} note${row.notes === 1 ? "" : "s"}` : null,
						row.signatures > 0 ? `${row.signatures} signature${row.signatures === 1 ? "" : "s"}` : null,
						row.statuses > 0 ? `${row.statuses} status${row.statuses === 1 ? "" : "es"}` : null,
						row.workflow_attempts > 0 ? `${row.workflow_attempts} workflow attempt${row.workflow_attempts === 1 ? "" : "s"}` : null,
						row.alert_responses > 0 ? `${row.alert_responses} alert response${row.alert_responses === 1 ? "" : "s"}` : null,
						row.financials_unsent ? "financials unsent" : null,
						row.ticket_information_unsent ? "ticket information unsent" : null,
						row.ticket_unsent ? "ticket row unsent" : null,
					].filter(Boolean);
					return (
						<div key={row.ticket} style={{marginBottom: 12}}>
							<strong>Ticket {row.ticket}</strong>
							<div>{row.reason}</div>
							<div>{row.opened ? `Opened ${row.opened}` : "Not opened"}{row.closed ? `; closed ${row.closed}` : "; not closed"}</div>
							<div>{counts.length > 0 ? counts.join(", ") : "No counted rows"}</div>
						</div>
					);
				})}
			</div>
		);
	}

	toggleClose = () => {
		this.setState({calendarAlerts: null, toggleAlerts: false})
	}
	handleStatusTime = (time, region) => {
		if (!time) {
			return "N/A";
		}
		const parts = time.date.split(' ')[1].split('.')[0].split(':');
		let endTime = moment().tz(region?.timezones?.php_timezone ? region?.timezones?.php_timezone : 'America/Phoenix');
		let startTime = moment().tz(region?.timezones?.php_timezone ? region?.timezones?.php_timezone : 'America/Phoenix');
		startTime.set({'hour': parts[0], 'minutes': parts[1], 'seconds': parts[2]})
		const diff = endTime.diff(startTime);
		const hours = Math.floor(diff / 3600000)
		const minutes = Math.floor((diff - (hours * 3600000)) / 60000)
		const seconds = Math.floor((diff - (hours * 3600000) - (minutes * 60000)) / 1000)

		return `${hours}h ${minutes}m ${seconds}s`
	}

	setAlertModalData = async (key) => {
		if (!this.props.engineer) {
			return []
		}
		const data = await Promise.all(this.props.engineer.alerts.filter((alert) => alert.AlertStatus === key).map(async (item) => {
			const calendar = this.props.engineer.calendars.filter((_item) => _item.Pkey === item.Calendars)[0];
			await Object.keys(calendar).forEach(key => {
				item[key] = calendar[key]
			});
			return item
		}))

		this.setState({alert_modal_data: data})
	}

	render() {
		this.state.selectedDay = this.props?.currentDay ?? moment().format("YYYY-MM-DD");
		const dispatchView = !this.props.rootState.roles.some(role => [10, 20, 25, 26].includes(role));
		const canLinkToUserProfile = this.props.rootState.roles.some(role => MANAGER_PLUS_ROLES.includes(role));
		let columns = dispatchView ? [
			{
				Header: "Time",
				id: "time",
				accessor: obj => (obj.time)
			},
			{
				Header: "Client Name",
				id: "name",
				accessor: obj => (obj.customer_name),
				Cell: props => {
					return (
						<span>
							<Link to={`/customers/${props.original.customer_pkey}`}>
								{props.original.customer_name}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "FD Ticket #",
				id: "fresh_ticket",
				accessor: obj => (obj.fresh_ticket),
				Cell: props => {
					return (
						<span>
							<FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />
						</span>
					);
				}
			},
			{
				Header: "Onsite",
				id: "on_site_time",
				accessor: obj => obj.on_site_time ? moment(obj.on_site_time).format('h:mm A') : ''
			},
			{
				Header: "Offsite",
				id: "off_site_time",
				accessor: obj => obj.off_site_time ? moment(obj.off_site_time).format('h:mm A') : ''
			},

		] : [
			{
				Header: "Time",
				id: "time",
				accessor: obj => (obj.time)
			},
			{
				Header: "Client Name",
				id: "name",
				accessor: obj => (obj.customer_name),
				Cell: props => {
					return (
						<span>
							<Link to={`/customers/${props.original.customer_pkey}`}>
								{props.original.customer_name}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "FD Ticket #",
				id: "fresh_ticket",
				accessor: obj => (obj.fresh_ticket),
				Cell: props => {
					return (
						<span>
							<FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />
						</span>
					);
				}
			},
			{
				Header: "Onsite",
				id: "on_site_time",
				accessor: obj => obj.on_site_time ? moment(obj.on_site_time).format('h:mm A') : ''
			},
			{
				Header: "Offsite",
				id: "off_site_time",
				accessor: obj => obj.off_site_time ? moment(obj.off_site_time).format('h:mm A') : ''
			},
			{
				Header: "Waived",
				id: "waived",
				Cell: (props) => {
					const obj = props.original || {};

					const waivedItems = [];

					if (obj.anti_virus_signed && obj.anti_virus_signed !== "0") waivedItems.push("Anti-Virus");
					if (obj.data_backup_signed && obj.data_backup_signed !== "0") waivedItems.push("Data Backup");
					if (obj.hdd_inspection_signed && obj.hdd_inspection_signed !== "0") waivedItems.push("HDD Inspection");
					if (obj.network_signed && obj.network_signed !== "0") waivedItems.push("Network");

					const waivedCount = waivedItems.length;

					const hasOffsite = !!obj.off_site_time;

					// If not offsite yet → treat as none
					if (!hasOffsite || waivedCount === 0) {
						return (
							<Tooltip title="Number of 4 Point Inspections Waived" arrow>
								<span style={{
									color: "green", fontWeight: 600, width: '100%',
									height: '100%',
									display: 'flex'
								}}>
									None
								</span>
							</Tooltip>
						);
					}

					return (
						<Tooltip title="Number of 4 Point Inspections Waived" arrow>
							<span
								style={{
									color: "red",
									fontWeight: 600,
									cursor: "pointer",
									width: '100%',
									height: '100%',
									display: 'flex'
								}}
								onClick={() =>
									this.setState({
										modal_obj: obj,
										waived_items: waivedItems,
										waived_modal: true,
									})
								}
							>
								{waivedCount}
							</span>
						</Tooltip>
					);
				}
			},
			{
				Header: "Cards",
				id: "cards",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 73,
				accessor: obj => obj.pkey,
				Cell: props => {
					return (
						<div style={{textAlign: 'center'}}>
							<Checkbox
								checked={props.original.other_notes === "left cards"}
								color={'primary'}
								disabled={true}
							/>
						</div>
					);
				}
			},
			{
				Header: "Amount",
				id: "amount",
				accessor: obj => (obj.finance_amount),
				width: 100,
				className: "button-cell",
				Cell: props => {
					return (
						props.original.financial_pkey ?
							<Button
								color={'primary'}
								size={"sm"} block={true}
								onClick={() => {
									this.setState({
										financial: props.original.financial_pkey,
										ticket: props.original.Ticket,
									}, () => this.handleToggleModal('showFinancialModal'));
								}}
							>
								{props.original.finance_amount}
							</Button> : null
					);
				}
			},
		]

		if (moment().format('YYYY-MM-DD') === this.props.currentDay) {
			columns.push({
				Header: "Progress",
				className: 'button-cell',
				filterable: false,
				sortable: false,
				width: 200,
				Cell: props => {
					const {ticket_progress} = props.original
					return (
						<span>
							<TicketProgressDisplay
								progress={ticket_progress}
								emptyLabel="N/A"
								showActive
							/>
						</span>
					)
				}
			})
		}


		if (!dispatchView) {
			columns.push({
					Header: "Score",
					className: 'button-cell',
					filterable: false,
					sortable: false,
					width: 100,
					Cell: props => {
						const {ticket_score, ticket_score_pkey} = props.original
						return (
							<span onClick={async () => {
								if (ticket_score && ticket_score_pkey) {
									let scores_model = new API.BuildClass(Types.Engineer_Scores._name, API.RequestType.READ);
									scores_model.object.pkey = ticket_score_pkey;
									const scores = await scores_model.submit(null, 'GET')
									this.setState({ticket_scores: scores})
									this.handleToggleModal('modal_breakdown');
								}
							}}>
								{ticket_score ? <GradeComponent score={ticket_score}/> :
									<b>N/A</b>}
							</span>
						)
					}
				},
				{
					Header: "Review",
					id: "review",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 100,
					accessor: obj => obj.pkey,
					Cell: props => <TicketAuditReviewLink row={props.original}/>
				},
				{
					Header: "Reviewed By",
					id: 'userChecked',
					accessor: obj => (obj.userChecked)
				},
				{
					Header: "Ticket",
					id: "ticket_review",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 75,
					accessor: obj => obj.pkey,
					Cell: props => {
						return (
							<Button color="blue-hoki" size={"sm"} block={true} onClick={() => {
								this.setState({ticket: props.original.Ticket}, () => {
									this.handleToggleModal('showTicketModal');
								});
							}}>
								<Search fontSize={'small'}/>
							</Button>
						);
					}
				})

		}

		const {engineer} = this.props;

		if (!engineer) {
			return null;
		}

		const displayedElapsedTime = engineer.current_status ? this.handleStatusTime(engineer.current_status_time, engineer.regions) : "0";

		const now = moment().tz('America/Phoenix');
		const lastContactedAt = engineer.last_contacted
			? moment.tz(engineer.last_contacted, 'America/Phoenix')
			: null;
		const lastContactedDate = engineer.last_contacted_date
			|| (lastContactedAt ? lastContactedAt.format('YYYY-MM-DD') : null);
		const calendarDaysAgo = lastContactedDate
			? now.clone().startOf('day').diff(moment.tz(lastContactedDate, 'America/Phoenix').startOf('day'), 'days')
			: null;
		const duration = lastContactedAt ? moment.duration(now.diff(lastContactedAt)) : null;
		const hours = duration ? Math.floor(duration.asHours()) : 0;
		const minutes = duration ? duration.minutes() : 0;
		const lastContactedLabel = calendarDaysAgo == null
			? 'Never contacted'
			: (calendarDaysAgo >= 1
				? `${calendarDaysAgo} day${calendarDaysAgo !== 1 ? 's' : ''} ago`
				: `${hours} hour${hours !== 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''} ago`);
		const openContactedPage = () => {
			goToHelpdeskContacted(this.props.history, engineer.pkey, lastContactedDate);
		};
		return (
			<div key={'engineer_card_' + engineer.pkey}>
				<Modal
					isOpen={this.state.waived_modal}
					toggle={() => this.setState({waived_modal: false})}
					size="sm"
					backdrop
				>
					<ModalHeader toggle={() => this.setState({waived_modal: false})}>
						Waived 4-Point Inspections
					</ModalHeader>

					<ModalBody>
						{this.state.waived_items?.length === 0 ? (
							<div>None waived</div>
						) : (
							<ul style={{marginBottom: 0}}>
								{this.state.waived_items.map(item => (
									<li key={item}>{item}</li>
								))}
							</ul>
						)}
					</ModalBody>

					<ModalFooter>
						<Button
							color="secondary"
							onClick={() =>
								this.setState({
									waived_modal: false,
									modal_obj: null,
									waived_items: [],
								})
							}
						>
							Cancel
						</Button>
					</ModalFooter>
				</Modal>


				{dispatchView ? <Card>
					<CardHeader style={window.innerHeight >= 760 ? {marginBottom: '-15px'} : null} title={<div className={'row'}>
						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TextField
									fullWidth={true}
									size={"small"}
									label={"Field Engineer"}
									value={engineer.name_first + " " + engineer.name_last}
									variant="outlined"
									{...(canLinkToUserProfile
										? {
											onClick: () => this.props.history.push(`/users/${engineer.pkey}`),
											inputProps: {
												readOnly: true,
												style: {cursor: 'pointer', color: '#0d6efd', textDecoration: 'underline'},
											},
										}
										: {disabled: true}
									)}
								/>
							</div>
						</div>
						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TextField
									fullWidth={true}
									size={"small"}
									label={"Phone"}
									value={(engineer.phone_cell && engineer.phone_cell.slice(0, 3) + "-" + engineer.phone_cell.slice(3, 6) + "-" + engineer.phone_cell.slice(6, engineer.phone_cell.length))}
									variant="outlined"
									disabled={true}
								/>
							</div>
						</div>
						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TextField
									fullWidth={true}
									size={"small"}
									label={"Today's Avg"}
									value={engineer.engineer_stats[0]?.total_stats_today}
									variant="outlined"
									disabled={true}
								/>
							</div>
						</div>
						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TextField
									fullWidth={true}
									size={"small"}
									label={"7day Avg"}
									value={engineer.engineer_stats[0]?.total_stats_7day}
									variant="outlined"
									disabled={true}
								/>
							</div>
						</div>
						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TextField
									fullWidth={true}
									size={"small"}
									label={"30day Avg"}
									value={engineer.engineer_stats[0]?.total_stats_30day}
									variant="outlined"
									disabled={true}
								/>
							</div>
						</div>
						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TextField
									fullWidth={true}
									size={"small"}
									label={"Today's Labor Total"}
									value={engineer.engineer_stats[0]?.total_labor_today}
									variant="outlined"
									disabled={true}
								/>
							</div>
						</div>
						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TextField
									fullWidth={true}
									size={"small"}
									label={"Reviews 7day"}
									value={engineer.engineer_stats[0]?.reviews_7d}
									variant="outlined"
									disabled={true}
								/>
							</div>
						</div>
					</div>}/>
					<div style={{backgroundColor: "lightgray", paddingTop: 15}}>
						<div className={'row px-lg-3'}>
							<div className={'col-2'}>
								<div className={"form-group"}>
									<TextField
										key={displayedElapsedTime}
										fullWidth={true}
										size={"small"}
										label={"Current Status"}
										value={`${engineer.current_status}: ${displayedElapsedTime}`}
										variant="outlined"
										disabled={true}
									/>
								</div>
							</div>
							<div className={'col-2 ml-auto flex-end text-right'}>
								<div className={"form-group"}>
									<Button
										color={'primary'}
										size={"sm"} block={false}
										onClick={() => {
											this.state.engineer = engineer.pkey;
											this.handleToggleModal('help_desk_reschedule_modal');
										}}
									>
										Reschedule Last?
									</Button>
								</div>
							</div>
						</div>
					</div>
					<CardContent>
						<ReactTable
							key={engineer.calendars}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={engineer.calendars}
							loadingText="Requesting Data"
							expanderDefaults={{
								sortable: false,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							className="-striped -highlight"
							defaultPageSize={engineer.calendars.length}
							showPagination={false}
							getTdProps={() => {
								return {
									style: {
										height: '40px'
									}
								}
							}}
							getTrProps={(header, rowInfo) => {
								let start = rowInfo.original.End.split("T")[1].split(":")[0];
								let now = moment().hours();
								return {
									style: {
										background: start <= now ? '#D4D4D4' : null
									}
								};
							}}
						/>
					</CardContent>
				</Card> : <Card>
					<CardHeader style={window.innerHeight >= 760 ? {marginBottom: '-15px'} : null} title={<div className={'row px-lg-3'}>
						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TextField
									size={"small"}
									label={"Field Engineer"}
									value={engineer.name_first + " " + engineer.name_last}
									variant="outlined"
									{...(canLinkToUserProfile
										? {
											onClick: () => this.props.history.push(`/users/${engineer.pkey}`),
											inputProps: {
												readOnly: true,
												style: {cursor: 'pointer', color: '#0d6efd', textDecoration: 'underline'},
											},
										}
										: {disabled: true}
									)}
								/>
							</div>
						</div>
						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TextField
									size={"small"}
									label={"Phone"}
									value={(engineer.phone_cell && engineer.phone_cell.slice(0, 3) + "-" + engineer.phone_cell.slice(3, 6) + "-" + engineer.phone_cell.slice(6, engineer.phone_cell.length))}
									variant="outlined"
									disabled={true}
								/>
							</div>
						</div>
						{engineer.last_contacted ? <div className={'col-auto'} onClick={openContactedPage}>
							<div className={"form-group"}>
								<Tooltip title={(engineer.contacted_by + ' - ' + engineer.last_note)} arrow>
									<TextField
										size={"small"}
										label={"Last Contacted"}
										value={lastContactedLabel}
										variant="outlined"
										disabled={true}
										InputProps={{
											style: {
												pointerEvents: 'none', // This ensures the div's click event will trigger
											},
										}}
									/>
								</Tooltip>
							</div>
						</div> : <div className={'col-auto'} onClick={openContactedPage}>
							<div className={"form-group"}>
								<Tooltip title={"This FE has never been contacted."} arrow>
									<TextField
										size={"small"}
										label={"Last Contacted"}
										value={'Never contacted'}
										variant="outlined"
										disabled={true}
										InputProps={{
											style: {
												pointerEvents: 'none', // This ensures the div's click event will trigger
											},
										}}
									/>
								</Tooltip>
							</div>
						</div>}

						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TextField
									size={"small"}
									label={"Today's Average"}
									value={engineer.engineer_stats[0]?.total_stats_today + ' / ' + getLetterGrade(engineer.score_avg_today) + getGradeSign(engineer.score_avg_today) + " " + (Math.round(parseFloat(engineer.score_avg_today ?? 0) * 10) / 10) + '%'}
									variant="outlined"
									disabled={true}
								/>
							</div>
						</div>
						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TextField
									size={"small"}
									label={"7day Average"}
									value={engineer.engineer_stats[0]?.total_stats_7day + ' / ' + getLetterGrade(engineer.score_avg_7day) + getGradeSign(engineer.score_avg_7day) + " " + (Math.round(parseFloat(engineer.score_avg_7day ?? 0) * 10) / 10) + '%'}
									variant="outlined"
									disabled={true}
								/>
							</div>
						</div>
						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TextField
									size={"small"}
									label={"30day Average"}
									value={engineer.engineer_stats[0]?.total_stats_30day + ' / ' + getLetterGrade(engineer.score_avg_30day) + getGradeSign(engineer.score_avg_30day) + " " + (Math.round(parseFloat(engineer.score_avg_30day ?? 0) * 10) / 10) + '%'}
									variant="outlined"
									disabled={true}
								/>
							</div>
						</div>
						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TextField
									size={"small"}
									label={"Today's Labor Total"}
									value={engineer.engineer_stats[0]?.total_labor_today}
									variant="outlined"
									disabled={true}
								/>
							</div>
						</div>
						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TrendStackedMetric
									metric={"reviews"}
									label={"Reviews 7 / 30 / 90 day"}
									values={[engineer.reviews_7d, engineer.reviews_30d, engineer.reviews_90d]}
									baseline={engineer.reviews_180d}
								/>
							</div>
						</div>
						<div className={'col-auto'}>
							<div className={"form-group"}>
								<TrendStackedMetric
									metric={"avSales"}
									label={"AV Sales 7 / 30 / 90 day"}
									values={[engineer.av_7day, engineer.av_30day, engineer.av_90day]}
									baseline={engineer.av_180day}
								/>
							</div>
						</div>
					</div>}/>
					<div style={{backgroundColor: "lightgray", paddingTop: 15}}>
						<div className={'row px-lg-3'}>
							<div className={'col-2'}>
								<div className={"form-group"}>
									<TextField
										key={displayedElapsedTime}
										fullWidth={true}
										size={"small"}
										label={"Current Status"}
										value={`${engineer.current_status}: ${displayedElapsedTime}`}
										variant="outlined"
										disabled={true}
									/>
								</div>
							</div>
							{engineer.helpdesk_contacted?.length > 0 && <div className={'col-auto'}>
								<div className={"form-group"}>
									<Button
										color={'success'}
										size={"sm"} block={false}
										onClick={() => {
											this.state.helpdesk_contacted_data = engineer.helpdesk_contacted;
											this.handleToggleModal('help_desk_contacted_modal');
										}}
									>
										Engineer Contacted
									</Button>
								</div>
							</div>}
							{/*{*/}
							{/*	engineer.alerts?.map((alertitem) => {*/}
							{/*		switch (alertitem.AlertStatus) {*/}
							{/*			case 3:*/}
							{/*				return */}
							{/*			case 5:*/}
							{/*				return <div className={'col-2'}>*/}
							{/*					<div className={"form-group"}>*/}
							{/*						<Button*/}
							{/*							color={'danger'}*/}
							{/*							size={"sm"} block={false}*/}
							{/*							onClick={() => {*/}
							{/*							}}*/}
							{/*						>*/}
							{/*							Underbilled*/}
							{/*						</Button>*/}
							{/*					</div>*/}
							{/*				</div>*/}
							{/*			case 7:*/}
							{/*				return <div className={'col-2'}>*/}
							{/*					<div className={"form-group"}>*/}
							{/*						<Button*/}
							{/*							color={'danger'}*/}
							{/*							size={"sm"} block={false}*/}
							{/*							onClick={() => {*/}
							{/*							}}*/}
							{/*						>*/}
							{/*							Long Site Time*/}
							{/*						</Button>*/}
							{/*					</div>*/}
							{/*				</div>*/}
							{/*		}*/}
							{/*	})*/}
							{/*}*/}

							{engineer.alerts.some((item) => item.AlertStatus === 1) && <div className={'col-auto'}>
								<div className={"form-group"}>
									<Button
										color={'danger'}
										size={"sm"} block={false}
										onClick={async () => {
											this.setState({modal_alert_header: 'All 60 Min End Window Alerts', alert_key: 1})
											await this.setAlertModalData(1)
											this.setState({modal_alert_display: true})
										}}
									>
										60 Min End
										Window {engineer.alerts.filter((item) => item.AlertStatus === 1).length > 1 ? (' x' + engineer.alerts.filter((item) => item.AlertStatus === 1).length) : ''}
									</Button>
								</div>
							</div>}
							{engineer.alerts.some((item) => item.AlertStatus === 2) && <div className={'col-auto'}>
								<div className={"form-group"}>
									<Button
										color={'danger'}
										size={"sm"} block={false}
										onClick={async () => {
											this.setState({modal_alert_header: 'All 30 Min End Window Alerts', alert_key: 2})
											await this.setAlertModalData(2)
											this.setState({modal_alert_display: true})
										}}
									>
										30 Min End
										Window {engineer.alerts.filter((item) => item.AlertStatus === 2).length > 1 ? (' x' + engineer.alerts.filter((item) => item.AlertStatus === 2).length) : ''}
									</Button>
								</div>
							</div>}
							{engineer.alerts.some((item) => item.AlertStatus === 3) && <div className={'col-auto'}>
								<div className={"form-group"}>
									<Button
										color={'danger'}
										size={"sm"} block={false}
										onClick={async () => {
											this.setState({modal_alert_header: 'All Late for First Alerts', alert_key: 3})
											await this.setAlertModalData(3)
											this.setState({modal_alert_display: true})
										}}
									>
										Late for
										First {engineer.alerts.filter((item) => item.AlertStatus === 3).length > 1 ? (' x' + engineer.alerts.filter((item) => item.AlertStatus === 3).length) : ''}
									</Button>
								</div>
							</div>}
							{engineer.alerts.some((item) => item.AlertStatus === 4) && <div className={'col-auto'}>
								<div className={"form-group"}>
									<Button
										color={'danger'}
										size={"sm"} block={false}
										onClick={async () => {
											this.setState({modal_alert_header: 'All Late Alerts', alert_key: 4})
											await this.setAlertModalData(4)
											this.setState({modal_alert_display: true})
										}}
									>
										Late {engineer.alerts.filter((item) => item.AlertStatus === 4).length > 1 ? (' x' + engineer.alerts.filter((item) => item.AlertStatus === 4).length) : ''}
									</Button>
								</div>
							</div>}
							{engineer.alerts.some((item) => item.AlertStatus === 5) && <div className={'col-auto'}>
								<div className={"form-group"}>
									<Button
										color={'danger'}
										size={"sm"} block={false}
										onClick={async () => {
											this.setState({modal_alert_header: 'All Under Bill Alerts', alert_key: 5})
											await this.setAlertModalData(5)
											this.setState({modal_alert_display: true})
										}}
									>
										Under
										Bill {engineer.alerts.filter((item) => item.AlertStatus === 5).length > 1 ? (' x' + engineer.alerts.filter((item) => item.AlertStatus === 5).length) : ''}
									</Button>
								</div>
							</div>}
							{engineer.alerts.some((item) => item.AlertStatus === 6) && <div className={'col-auto'}>
								<div className={"form-group"}>
									<Button
										color={'danger'}
										size={"sm"} block={false}
										onClick={async () => {
											this.setState({modal_alert_header: 'All Invoice Alerts', alert_key: 6})
											await this.setAlertModalData(6)
											this.setState({modal_alert_display: true})
										}}
									>
										Invoice {engineer.alerts.filter((item) => item.AlertStatus === 6).length > 1 ? (' x' + engineer.alerts.filter((item) => item.AlertStatus === 6).length) : ''}
									</Button>
								</div>
							</div>}
							{engineer.alerts.some((item) => item.AlertStatus === 7) && <div className={'col-auto'}>
								<div className={"form-group"}>
									<Button
										color={'danger'}
										size={"sm"} block={false}
										onClick={async () => {
											this.setState({modal_alert_header: 'All Long Site Time Alerts', alert_key: 7})
											await this.setAlertModalData(7)
											this.setState({modal_alert_display: true})
										}}
									>
										Long Site
										Time {engineer.alerts.filter((item) => item.AlertStatus === 7).length > 1 ? (' x' + engineer.alerts.filter((item) => item.AlertStatus === 7).length) : ''}
									</Button>
								</div>
							</div>}
							{engineer.push_notifications?.length > 0 && <div className={'col-auto'}>
								<div className={"form-group"}>
									<Button
										color={'danger'}
										size={"sm"} block={false}
										onClick={async () => {
											this.setState({notification_modal: true})
										}}
									>
										Push Notifications
										Sent {engineer.push_notifications.length > 1 ? (' x' + engineer.push_notifications.length) : ''}
									</Button>
								</div>
							</div>}
							{engineer.has_cached_data && <div className={'col-2 ml-auto flex-end text-right'}>
								<div className={"form-group"}>
									<Button
										color={'secondary'}
										size={"sm"} block={false}
										onClick={() => {
											this.setState({
												cached_data_modal: true,
												cachedReportEngineer: engineer,
											});
										}}
									>
										Has Cached Data
									</Button>
								</div>
							</div>}
							<div className={'col-2 ml-auto flex-end text-right'}>
								<div className={"form-group"}>
									<Button
										color={'primary'}
										size={"sm"} block={false}
										onClick={() => {
											this.state.engineer = engineer.pkey;
											this.handleToggleModal('help_desk_reschedule_modal');
										}}
									>
										Reschedule Last?
									</Button>
								</div>
							</div>
						</div>
					</div>
					<CardContent>
						<ReactTable
							key={engineer.calendars}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={engineer.calendars}
							loadingText="Requesting Data"
							expanderDefaults={{
								sortable: false,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							className="-striped -highlight"
							defaultPageSize={engineer.calendars.length}
							showPagination={false}
							getTdProps={() => {
								return {
									style: {
										height: '40px'
									}
								}
							}}
							getTrProps={(header, rowInfo) => {
								let start = rowInfo.original.End.split("T")[1].split(":")[0];
								let now = moment().hours();
								return {
									style: {
										background: start <= now ? '#D4D4D4' : null
									}
								};
							}}
						/>
					</CardContent>
				</Card>}

				<Modal
					isOpen={!!this.state.cached_data_modal}
					toggle={() => this.setState({cached_data_modal: false, cachedReportEngineer: null})}
					size="lg"
				>
					<ModalHeader toggle={() => this.setState({cached_data_modal: false, cachedReportEngineer: null})}>
						Cached data for {this.state.cachedReportEngineer?.name_first} {this.state.cachedReportEngineer?.name_last}
					</ModalHeader>
					<ModalBody>
						{this.renderCachedDataReport(this.state.cachedReportEngineer)}
					</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={() => this.setState({cached_data_modal: false, cachedReportEngineer: null})}>
							Close
						</Button>
					</ModalFooter>
				</Modal>
				<Framework.Elements.UniversalModal
					id={this.state.engineer ?? null}
					name={"Help Desk Reschedule Fourth"}
					title={"Help Desk Reschedule Fourth"}
					object={Objects.HelpDeskRescheduleFourth}
					history={this.props.history}
					toggle={this.state.help_desk_reschedule_modal}
					reportClose={() => this.handleToggleModal('help_desk_reschedule_modal')}
					hideGoTo={true}
					hasSubmit={false}
				/>
				<Framework.Elements.UniversalModal
					size={"sm"}
					parent={this.state.calendar ?? null}
					title={"Help Desk Alerts"}
					object={Collections.HelpDeskAlerts}
					history={this.props.history}
					toggle={this.state.help_desk_alerts_modal}
					reportClose={() => this.handleToggleModal('help_desk_alerts_modal')}
					hideGoTo={true}
					hasSubmit={false}
				/>
				<Framework.Elements.UniversalModal
					size={"xl"}
					title={"Help Desk Contacted"}
					object={Collections.HelpDesksContacted}
					history={this.props.history}
					toggle={this.state.help_desk_contacted_modal}
					reportClose={() => this.handleToggleModal('help_desk_contacted_modal')}
					hideGoTo={true}
					hasSubmit={false}
					objectProps={{contacted_data: this.state.helpdesk_contacted_data, forHelpdesk: true}}
				/>
				<Framework.Elements.UniversalModal
					size={"xl"}
					id={this.state.ticket}
					history={this.props.history}
					object={Objects.ScheduleTicket}
					submitLabel={"Update Ticket"}
					deleteLabel={"Delete Ticket"}
					locations={[""]}
					title={"Review Ticket"}
					toggle={this.state.showTicketModal}
					reportClose={() => this.handleToggleModal('showTicketModal')}
					hasDelete={false}
					hasSubmit={false}
					hideGoTo={true}
				/>
				<Framework.Elements.UniversalModal
					size={"md"}
					parent={this.state.ticket}
					id={this.state.financial}
					history={this.props.history}
					object={Objects.Financial}
					title={"Review Financial"}
					toggle={this.state.showFinancialModal}
					reportClose={() => this.handleToggleModal('showFinancialModal')}
					hasDelete={false}
					hasSubmit={false}
					hideGoTo={true}
					objectProps={{hideBack: true}}
				/>
				<Modal
					isOpen={this.state.modal_breakdown}
					toggle={() => this.handleToggleModal('modal_breakdown')}
					size={"lg"}
					backdrop={true}
				>
					<ModalHeader>
						Ticket Score Breakdown
					</ModalHeader>
					<ModalBody>
						<TicketScoreBreakdown scores={this.state.ticket_scores}/>
					</ModalBody>
					<ModalFooter>
						<Button color={'secondary'} onClick={() => {
							this.setState({scores: []})
							this.handleToggleModal('modal_breakdown')
						}}>
							Close
						</Button>
					</ModalFooter>
				</Modal>

				<Modal
					isOpen={this.state.modal_alert_display}
					toggle={() => this.handleToggleModal('modal_alert_display')}
					size={"md"}
					backdrop={true}
				>
					<ModalHeader>
						{this.state.modal_alert_header}
					</ModalHeader>
					<ModalBody>
						<ReactTable
							key={this.state.alert_key}
							columns={[
								{
									Header: "Client Name",
									id: "name",
									accessor: obj => (obj.customer_name),
									Cell: props => {
										return (
											<span>
												<Link to={`/customers/${props.original.customer_pkey}`}>
													{props.original.customer_name}
												</Link>
											</span>
										);
									}
								},
								{
									Header: "FD Ticket #",
									id: "fresh_ticket",
									accessor: obj => (obj.fresh_ticket),
									Cell: props => {
										return (
											<span>
												<FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />
											</span>
										);
									}
								}

							]}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={this.state.alert_modal_data}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							pages={1} // Display the total number of pages
							onFetchData={async () => {
								await this.setAlertModalData(this.state.alert_key)
							}} // Request new data when things change
							defaultPageSize={10}
							className="-striped -highlight"
							onPageSizeChange={() => {
							}}
							pageSizeOptions={[]}
							showPagination={false}
							pageSize={10}
						/>
					</ModalBody>
					<ModalFooter>
						<Button color={'secondary'} onClick={() => {
							this.setState({alert_key: null})
							this.handleToggleModal('modal_alert_display')
						}}>
							Close
						</Button>
					</ModalFooter>
				</Modal>

				<Modal
					isOpen={this.state.notification_modal}
					toggle={() => this.handleToggleModal('notification_modal')}
					size={"lg"}
					backdrop={true}
				>
					<ModalHeader>
						Push Notifications Sent
					</ModalHeader>
					<ModalBody>
						<ReactTable
							key={this.state.alert_key}
							columns={[
								{
									Header: "Date Sent",
									id: "date",
									accessor: obj => (moment(obj.date).format("YYYY-MM-DD h:mm A")),
								},
								{
									Header: "Client Name",
									id: "name",
									accessor: obj => (obj.customer_name),
								},
								{
									Header: "FD Ticket #",
									id: "fresh_ticket",
									accessor: obj => (obj.fresh_ticket),
									Cell: props => {
										return (
											<span>
												<FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />
											</span>
										);
									}
								},
								{
									Header: "Reasoning",
									id: "notification_types.message",
									accessor: obj => (obj.message),
								}

							]}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={engineer.push_notifications?.length > 0 ? engineer.push_notifications : []}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							pages={1} // Display the total number of pages
							defaultPageSize={10}
							className="-striped -highlight"
							onPageSizeChange={() => {
							}}
							pageSizeOptions={[]}
							showPagination={false}
							pageSize={10}
						/>
					</ModalBody>
					<ModalFooter>
						<Button color={'secondary'} onClick={() => {
							this.handleToggleModal('notification_modal')
						}}>
							Close
						</Button>
					</ModalFooter>
				</Modal>

			</div>
		)
	}
})

export default Framework.Components.withRootState(EngineerHDCard);